module.exports = __webpack_public_path__ + "static/media/ic_setting_blue.1b18d88c.svg";